var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84197 10.9631L11.905 5.90001M0.999983 16.8051L4.89464 16.8051L8.7893 12.9104L4.89464 9.01574L0.999983 12.9104L0.999983 16.8051ZM16.5786 5.12108L12.684 1.22642L12.2945 1.61589C12.0382 1.87133 11.8349 2.17483 11.6962 2.50899C11.5575 2.84315 11.4861 3.20141 11.4861 3.56322C11.4861 3.92503 11.5575 4.28329 11.6962 4.61745C11.8349 4.95161 12.0382 5.25511 12.2945 5.51055C12.5499 5.76679 12.8534 5.9701 13.1876 6.10882C13.5218 6.24754 13.88 6.31895 14.2418 6.31895C14.6036 6.31895 14.9619 6.24754 15.296 6.10882C15.6302 5.9701 15.9337 5.76679 16.1891 5.51055L16.5786 5.12108Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.eba25e06fb28babbe8f1451a49b3449e.svg";
export { ForwardRef as ReactComponent };